import ServiceModel   from '@models/ServiceModel';
import ApiConnectorV4 from '@/models/ApiConnectorV4';

const services = window.APP_CONFIG?.services || [];
const service = services.find(service => service.id === 'account');

export const accountApiEndpoint = service?.configurations.api_endpoint || '';

export const accountConnector = new ApiConnectorV4({ baseURL: accountApiEndpoint });

export default class AccountServiceModel extends ServiceModel {
	public static get connector() {
		return accountConnector;
	}

	public static serviceName = 'account';
	public static partitionName = '$';
}
